
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { Card, CardContent } from "@/components/ui/card";
import { CommissionOfferForm } from "@/components/commissions/CommissionOfferForm";
import { useCreateCommissionOffer } from "@/hooks/commission";
import { useUser } from "@/hooks/use-user";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { InfoIcon } from "lucide-react";

export default function CommissionCreatePage() {
  const navigate = useNavigate();
  const { user, isLoading: isUserLoading } = useUser();
  const { mutate: createOffer, isPending } = useCreateCommissionOffer();
  const [showSuccess, setShowSuccess] = useState(false);
  
  if (!isUserLoading && !user) {
    navigate("/auth");
    return null;
  }
  
  const handleSubmit = (data: any) => {
    if (!user) {
      toast.error("Você precisa estar logado para criar uma oferta");
      return;
    }
    
    console.log("Dados do formulário:", data);
    
    // Make sure artist_id is included
    const offerData = {
      ...data,
      artist_id: user.id
    };
    
    createOffer(offerData, {
      onSuccess: () => {
        setShowSuccess(true);
        setTimeout(() => {
          navigate("/commissions");
        }, 2000);
      },
      onError: (error) => {
        console.error("Erro ao criar oferta de comissão:", error);
        toast.error("Erro ao criar oferta de comissão");
      }
    });
  };
  
  return (
    <>
      <DashboardLayout title="Criar Oferta de Commissions">
        <div className="max-w-5xl mx-auto">
          <Card className="bg-[#121212] border-amber-500/20">
            <CardContent className="pt-6">
              <CommissionOfferForm 
                onSubmit={handleSubmit}
                isLoading={isPending}
                defaultValues={{
                  artist_id: user?.id
                }}
                additionalFields={{
                  accept_nft: {
                    tooltip: (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <InfoIcon className="h-4 w-4 text-muted-foreground cursor-help ml-1" />
                          </TooltipTrigger>
                          <TooltipContent>
                            <p>Ao escolher por este método você concorda com o uso do contrato inteligente</p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )
                  }
                }}
              />
            </CardContent>
          </Card>
        </div>
      </DashboardLayout>

      <Dialog open={showSuccess} onOpenChange={setShowSuccess}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-center">Comissão criada com sucesso!</DialogTitle>
          </DialogHeader>
          <p className="text-center">
            Sua oferta de comissão foi criada e já está disponível para os usuários.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
}
